// extracted by mini-css-extract-plugin
module.exports = {"features-list":"_0fce717cdb--features-list--MnIWc","feature-title":"_0fce717cdb--feature-title--Kf45Q","feature-item":"_0fce717cdb--feature-item--KlZyp"};